// Управляет CSS-переменными --font-size и --brightness-offset, которые
// влияют на размер шрифта всего интерфейса и на яркость приглушённого
// текста (muted-foreground). Сохраняется в localStorage.
import { writable } from "svelte/store";
// База приглушённого текста уже в globals.css на 0.80 OKLCH — дефолт ползунка
// 0 уже даёт хорошо читаемый текст. Юзер крутит симметрично в обе стороны.
const DEFAULT = { fontSize: 16, brightness: 0 };
// Версия ключа в localStorage: при смене дефолта/диапазона повышаем v -> сбрасывает
// устаревшие сохранённые значения у уже залогиненных юзеров.
const KEY = "piq.display.v4";
function load() {
    if (typeof localStorage === "undefined")
        return Object.assign({}, DEFAULT);
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw)
            return Object.assign({}, DEFAULT);
        const parsed = JSON.parse(raw);
        return {
            fontSize: typeof parsed.fontSize === "number" ? parsed.fontSize : DEFAULT.fontSize,
            brightness: typeof parsed.brightness === "number"
                ? parsed.brightness
                : DEFAULT.brightness,
        };
    }
    catch (_a) {
        return Object.assign({}, DEFAULT);
    }
}
export const displaySettings = writable(load());
function apply(s) {
    if (typeof document === "undefined")
        return;
    const root = document.documentElement;
    root.style.setProperty("--font-size", s.fontSize + "px");
    // brightness — это сдвиг в OKLCH lightness (0..1), 25 -> +0.05
    root.style.setProperty("--brightness-offset", String(s.brightness / 500));
}
displaySettings.subscribe((s) => {
    apply(s);
    if (typeof localStorage !== "undefined") {
        try {
            localStorage.setItem(KEY, JSON.stringify(s));
        }
        catch (_a) { }
    }
});
export function resetDisplay() {
    displaySettings.set(Object.assign({}, DEFAULT));
}
